import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { materialTypesActions } from '../actions/material-types.actions';
import { selectLoaded, selectMaterials, selectMaterialsLoading, selectMaterialTypes } from '../selectors/material-types.selector';

@Service()
export class MaterialTypesFacade {
    private readonly store = inject(Store);

    readonly materialTypes = this.store.selectSignal(selectMaterialTypes);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly materials = this.store.selectSignal(selectMaterials);
    readonly materialsLoading = this.store.selectSignal(selectMaterialsLoading);

    getMaterialTypes(): void {
        this.store.dispatch(materialTypesActions.getMaterialTypes());
    }

    getMaterials(id: string): void {
        this.store.dispatch(materialTypesActions.getMaterials({ id }));
    }

    clear(): void {
        this.store.dispatch(materialTypesActions.clear());
    }
}
